import { Polyglot } from "./Polyglot.js";

async function loadLocaleResourcesFromModules(locale, modules = {}) {

    const result = [];

    for (const [path, moduleLoader] of Object.entries(modules || {})) {
        const match = path.match(/\/locales\/([^/]+)\//);
        if (!match || match[1] !== locale)
            continue;

        const module = (typeof moduleLoader === 'function')
            ? await moduleLoader()
            : moduleLoader;
        const resources = module?.resources;
        if (!resources) {
            console.warn(`Module ${path} does not export "resources".`);
            continue;
        }

        result.push(resources);
    }

    return result;

}

const i18n = new Polyglot();

i18n.setLocaleResourceLoader = function (resourceLoader) {

    this.localeLoader = (typeof resourceLoader === 'function') ? resourceLoader : null;
    return this;

};

i18n.setLocaleResourceModules = function (modules = {}) {

    return this.setLocaleResourceLoader((locale) => loadLocaleResourcesFromModules(locale, modules));

};

export {
    i18n,
    loadLocaleResourcesFromModules,
};
